import { getCheckoutContent as publicGetCheckoutContent } from './ecom-api-v1-checkout-content-provider-checkout-content.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const getCheckoutContent: MaybeContext<
  BuildRESTFunction<typeof publicGetCheckoutContent> &
    typeof publicGetCheckoutContent
> = /*#__PURE__*/ createRESTModule(publicGetCheckoutContent);

export {
  CheckoutContentProvider,
  GetCheckoutContentRequest,
  GetCheckoutContentResponse,
  CheckoutContent,
  GetCheckoutContentIdentifiers,
  GetCheckoutContentOptions,
} from './ecom-api-v1-checkout-content-provider-checkout-content.universal.js';
export { GetCheckoutContentApplicationErrors } from './ecom-api-v1-checkout-content-provider-checkout-content.universal.js';
